export default __webpack_public_path__ + "static/media/BCI.72e33273.png";